import React, { useState, useRef } from "react";
import Swal from "sweetalert2";

export const ColorPickerModal = ({ initialColor, onSave, onClose }) => {
  const [localTextColor, setLocalTextColor] = useState(initialColor || "#000000");
  const debounceTimer = useRef(null);

  const handleColorChange = (color) => {
    setLocalTextColor(color);

    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    debounceTimer.current = setTimeout(() => {
      console.log("Color updated:", color); // Optional: Add any live preview logic here
    }, 300); // Debounce delay
  };

  const handleSave = async () => {
    try {
      await onSave(localTextColor); // Call the save function passed from the parent
      Swal.fire("Success", "Text color updated successfully!", "success");
      onClose(); // Close the modal
    } catch (error) {
      console.error("Error saving color:", error);
      Swal.fire("Error", "Failed to save the color!", "error");
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg w-full max-w-md shadow-xl">
        <h3 className="text-xl font-semibold text-center mb-4 text-black">Pick a Color</h3>
        <div className="flex items-center gap-4">
          {/* Color Picker */}
          <input
            type="color"
            value={localTextColor}
            className="w-12 h-12 rounded-md cursor-pointer border border-gray-300"
            onChange={(e) => handleColorChange(e.target.value)}
          />

          {/* Hex Code Input */}
          <input
            type="text"
            value={localTextColor}
            className="border rounded-md p-2 w-32 text-black"
            placeholder="#FFFFFF"
            onChange={(e) => setLocalTextColor(e.target.value)}
          />
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end gap-4 mt-6">
          <button
            className="px-4 py-2 bg-gray-300 text-black rounded-md hover:bg-gray-400 transition"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition"
            onClick={handleSave}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default ColorPickerModal;